<template>
  <nav class="tw-grid tw-justify-between" :class="gridColumns">
    <NavLink v-for="link in links" :key="link.path" :link="link" />
    <NavLink
      v-if="$flagsmith.hasFeature('casewise_support_request')"
      :link="ReportIssueLink"
      @click="openReportIssue"
    />
  </nav>
</template>

<script setup lang="ts">
import FilledFiles from '~icons/fluent/folder-open-24-filled'
import OutlinedFiles from '~icons/fluent/folder-open-24-regular'
import FilledHome from '~icons/fluent/home-24-filled'
import OutlinedHome from '~icons/fluent/home-24-regular'
import FilledReportIssue from '~icons/fluent/person-feedback-24-filled'
import OutlinedReportIssue from '~icons/fluent/person-feedback-24-regular'
import FilledHelpIcon from '~icons/fluent/question-circle-24-filled'
import OutlinedHelpIcon from '~icons/fluent/question-circle-24-regular'

const HomeLink = {
  path: '/',
  text: 'Home',
  filledIcon: FilledHome,
  outlinedIcon: OutlinedHome,
}

const FilesLink = {
  path: '/files',
  text: 'Files',
  filledIcon: FilledFiles,
  outlinedIcon: OutlinedFiles,
}

const ContactUsLink = {
  path: '/help',
  text: 'Contact us',
  filledIcon: FilledHelpIcon,
  outlinedIcon: OutlinedHelpIcon,
}

const ReportIssueLink = {
  text: 'Report issue',
  filledIcon: FilledReportIssue,
  outlinedIcon: OutlinedReportIssue,
}

const links = [HomeLink, FilesLink, ContactUsLink]

const { $flagsmith } = useNuxtApp()
const $analytics = useAnalytics()
const { open } = useReportIssueDrawer()

const gridColumns = computed(() =>
  $flagsmith.hasFeature('casewise_support_request') ? 'tw-grid-cols-4' : 'tw-grid-cols-3',
)

function openReportIssue() {
  $analytics.trackElementClicked({ elementType: 'navigation', text: 'report issue' })
  open()
}
</script>
